// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MSpW","toggle":"styles_toggle__kaN_9","preview":"styles_preview__Lt2Dp"};